import { FC } from 'react';
import { Box, Card, CardContent, CardHeader, Divider, Grid, Typography } from '@mui/material';
import links from './links.json';
import users from './users.json';
import { COLORS } from '../../services/constants/colors';

export const Links: FC = () => {
	const addEmail = (text: string) => {
		const curlyBracesRegex = /\{([^}]+)\}/g;
		const matches = text.match(curlyBracesRegex);
		let modifiedText = text;

		if (matches) {
			matches.forEach((match) => {
				const word = match.slice(1, -1);
				const email = users?.[word as unknown as keyof typeof users] ?? word;

				modifiedText = modifiedText.replace(
					match,
					`<a style="color: #006193; text-decoration: none" href="mailto:${String(
						email ?? '',
					)}">${word}</a>`,
				);
			});
		}
		return modifiedText;
	};
	const createMarkup = (txt: string) => {
		return { __html: txt };
	};

	return (
		<div style={{ margin: '0 15px' }}>
			<Grid container spacing={2}>
				{links.map((link) => (
					<Grid item xs={12} sm={6} md={3} key={link.name}>
						<Card
							sx={{
								display: 'flex',
								flexDirection: 'column',
								// justifyContent: 'space-between',
								// alignItems: '',
								height: '100%',
								// padding: '10px',
							}}
						>
							<CardHeader
								color="primary"
								sx={{
									padding: '10px',
									alignItems: 'start',
									wordBreak: 'break-all',
									fontWeight: 'bold',
									backgroundColor: link.deprecated ? COLORS.BACKGROUND_SECONDARY : COLORS.PRIMARY,
									color: link.deprecated ? COLORS.PRIMARY : '#fff',
									wordWrap: 'normal!important',
									minHeight: '90px',
									'& .MuiCardHeader-content': {
										display: 'flex',
										flexDirection: 'column',
										justifyContent: 'space-between',
										height: '100%',
									},

									'& .MuiCardHeader-title': {
										fontSize: '1rem',
										fontWeight: 'bold',
										wordWrap: 'normal!important',
										wordBreak: 'keep-all',
										display: 'block',
									},
									'& .MuiCardHeader-subheader': {
										display: 'block',
										fontSize: '0.8rem',
										'& a': {
											color: link.deprecated ? COLORS.PRIMARY : '#fff!important',
											textDecoration: 'none',
										},
										'& a:hover': {
											textDecoration: 'underline',
											// color: '#fff',
										},
										'& span': {
											fontSize: '0.7rem',
											color: link.deprecated ? COLORS.PRIMARY : '#ffffff96',
										},
									},
								}}
								// avatar={<Avatar alt="EAS Dashboard" src="/img/EAS-logo.svg" />}
								// action={
								// 	<IconButton aria-label="settings">
								// 		<MoreVertIcon />
								// 	</IconButton>
								// }
								title={link.name}
								subheader={
									<Box>
										{link?.devUrl && <span>prod: </span>}
										<a
											href={link.prodUrl}
											target="_blank"
											rel="noopener noreferrer"
											style={{ color: link.deprecated ? COLORS.PRIMARY : '#006193' }}
										>
											{link.prodUrl}
										</a>
										{link?.devUrl && (
											<>
												<br />
												<span>test: </span>
												<a
													href={link.devUrl}
													target="_blank"
													rel="noopener noreferrer"
													style={{ color: link.deprecated ? COLORS.PRIMARY : '#006193' }}
												>
													{link.devUrl}
												</a>
											</>
										)}
									</Box>
								}
							/>
							<CardContent
								sx={{
									padding: '10px',
									display: 'flex',
									flexDirection: 'column',
									justifyContent: 'space-between',
									paddingBottom: '10px!important',
									height: '100%',
									minHeight: '100px',
								}}
							>
								<Typography variant="body2" color="text.secondary">
									{link?.description ?? ' '}
								</Typography>
								{link.accessDescription && (
									<Box>
										<Divider sx={{ mt: 1, mb: 1 }} />
										<Typography component="div" variant="body2" color="text.secondary">
											<div
												dangerouslySetInnerHTML={createMarkup?.(
													addEmail?.(link?.accessDescription ?? ''),
												)}
											/>
										</Typography>
									</Box>
								)}
							</CardContent>
						</Card>
					</Grid>
				))}
			</Grid>
		</div>
	);
};
